import { Box, Stack, Typography } from "@mui/material";
import DataErrorDialogIcon from "@entrilia/shared/icons/DataErrorDialogIcon";

interface Props {
  message?: string;
}
const ErrorDocumentPreview = ({ message }: Props) => (
  <Box
    sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1, width: "100%", height: "100%" }}
  >
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <DataErrorDialogIcon sx={{ width: 80, height: 80 }} />
      <Typography color="textSecondary">{message ?? "Failed to preview document"}</Typography>
    </Stack>
  </Box>
);

export default ErrorDocumentPreview;
